export enum ChartDirectionEnum {
    horizontal = 'HORIZONTAL',
    vertical = 'VERTICAL'
}